import { ID } from '../../utils/codecUtils';
import { documentSchema } from '../models/document.schema';

export const get = (documentId: ID) => {
  return {
    endpoint: `/documents/${documentId}`,
    method: 'GET',
    responseSchema: documentSchema,
  } as const;
};
